// back-to-top
(function () {
  $(window).scroll(function () {
    if ($(document).scrollTop() >= 500) {
      $(".back-to-top").addClass('is-active');
      $(".back-to-top").show();
      $(".back-to-top").click(function () {
        $("body,html").scrollTop(0);
      });
    } else {
      $(".back-to-top").hide();
    }
  });
})();

//系统识别
function system_confirm(){var userAgentInfo = navigator.userAgent;if(userAgentInfo.indexOf("Win")>-1){return "win"}else if(userAgentInfo.indexOf("Mac")>-1){return "mac"}};function device_confirm(){var userAgentInfo = navigator.userAgent;var Agents = ["Android", "iPhone","SymbianOS", "Windows Phone","iPad", "iPod"];var flag = true;for (var v = 0; v < Agents.length; v++) {if (userAgentInfo.indexOf(Agents[v]) > 0) {flag = false;break;}}return flag;};
if(system_confirm()=="mac"&&device_confirm()){var isMac=true}
else if(system_confirm()=="win"&&device_confirm()){var isMac=false}
if(device_confirm()==true){var device_id=true}
else if(device_confirm()==false){var device_id=false}else{};
function system_fn(){
    if (isMac == true) {
        $('.sys_mac').addClass('active').siblings('.sys_win').removeClass('active');
        $('.mac_btn_box').css({"display": "-webkit-box","display":"-webkit-flex","display":"flex"});
        $('.mac_btn').css({"display":"block"});
        $('.mac_inline').css({"display":"inline-block"});
        $('.win_inline').css({"display":"none"});
        $('.win_btn_box').css({"display":"none"});
        $('.win_btn').css({"display":"none"});
    } else if (!isMac == true) {
        $('.sys_win').addClass('active').siblings('.sys_mac').removeClass('active');
        $('.win_btn_box').css({"display": "-webkit-box","display":"-webkit-flex","display":"flex"});
        $('.win_btn').css({"display":"block"});
        $('.mac_inline').css({"display":"none"});
        $('.win_inline').css({"display":"inline-block"});
        $('.mac_btn_box').css({"display":"none"});
        $('.mac_btn').css({"display":"none"});
    } else if (device_id == false) {
        $('.pc_btn').css({"display":"none"});
        $('.mac_inline').css({"display":"none"});
        $('.win_inline').css({"display":"inline-block"});
    };
};
system_fn();

// 上导航
$('.header .toggle').click(function(){
    $(this).toggleClass('active')
    $('.header .header_nav').toggle()
})
// 定义 debounce 函数
function debounce(func, delay) {
    let timer = null;
    return function() {
        const context = this;
        const args = arguments;
        clearTimeout(timer);
        timer = setTimeout(() => {
            func.apply(context, args);
        }, delay);
    };
}

$(document).ready(function() {
    header_resize();
});

function header_resize(){
    if($(window).width()>1200){
        $('.header .toggle').removeClass('active')
        $('.header .header_nav').show()
        $('.header .header_nav li').on('mouseenter', debounce(function(){
            $(this).addClass('active').siblings().removeClass('active');
            $(this).find('.drop_list_box').show();
            $(this).siblings().find('.drop_list_box').hide();
          }, 100))
          $('.header .header_nav li').on('mouseleave', function(){
            $(this).removeClass('active');
            $(this).find('.drop_list_box').hide();
            $(this).siblings().find('.drop_list_box').hide();
          });
    } else {
        $('.header .toggle').removeClass('active')
        $('.header .header_nav').hide()
        // 修改为点击事件
        $('.header .header_nav li').on('click', function() {
            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
                $(this).find('.drop_list_box').hide();

            } else {
                $(this).addClass('active').siblings().removeClass('active');
                $(this).find('.drop_list_box').show();
                $(this).siblings().find('.drop_list_box').hide();
            }
        });
    }
}


// 修改宽度重新运行
var editor_widht_fn=[]
var window_width=$(window).width();
$(window).resize(function(){
    if(window_width!=$(window).width()){
        // 多处理的函数
        for(var i=0;i<editor_widht_fn.length;i++){
            editor_widht_fn[i]()
        }
        window_width=$(window).width()
    }
})
editor_widht_fn.push(function(){
    header_resize()
})
// 下导航
$('.footer .box dl dt').click(function(){
    $(this).parent().toggleClass('active')
})
$('.footer .box .language>span').click(function(){
    $(this).toggleClass('active')
    $('.footer .box .language_box').toggle()
})

// 订阅
$('.footer .box .subscribe_btn').click(function(){
    $('.subscribe_mask').show()
    $('.subscribe_box div .error_p').hide()
    $('.subscribe_box div input').val('')
})
$('.subscribe_box .close').click(function(){
    $('.subscribe_mask').hide()
})
var reg_email = /^[a-zA-Z0-9.!#$%&#$%&amp; '*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
$('.subscribe_box div .btn').click(function(){
    if(reg_email.test($('.subscribe_box div input').val())){
        $.post('https://www.streambyte.net/api/subscribe.php',{
            email:$('.subscribe_box div input').val(),
            source:1,
        },function(res){
            console.log(res)
        })
        $('.subscribe_mask').hide()
        $('.subscribe_box div input').val('')
    }else{
        $('.subscribe_box div .error_p').show()
    }
})

var downList = {
    'music': ['streambyte-for-music.exe','mac-streambyte-for-music.dmg'],
    'video': ['streambyte-for-video.exe','mac-streambyte-for-video.dmg'],
};

var newWindow;
var download_page = '';
document.querySelectorAll('a[href$="dmg"], a[href$="exe"]').forEach(function(item){
    item.addEventListener('click', function(e){
        e.preventDefault();
        if(!device_confirm()){
            // 如果是移动端跳到另一个页面
            download_page = '/mobile-download/?pro=';
        }
        else{
            download_page = '/start-downloading/?pro=';
        }
        newWindow = window.open('about:blank','')
        for(var i in downList) {
            downList[i].forEach(function(val){
                if(item.getAttribute('href').match(val) !== null){
                    var _val = val;
                    if (_val.startsWith('mac-')) {
                        _val = _val.substring(4);
                    }
                    const extractedName = _val.substring(0, _val.lastIndexOf('.'));
                    newWindow.location.href = window.location.origin + download_page + extractedName;
                    if(!device_confirm()){
                        newWindow.location.href = window.location.origin + download_page + extractedName;
                    }
                }
            })
        };
        if(device_confirm()){
            window.location.href = item.getAttribute('href');
        }
    })
});